AddPageSwapTrigger(function () {
  var input = document.getElementById('storeSearch');
  if (!input) return;

  // Dubbele listeners voorkomen
  var isBound = input.dataset ? input.dataset.storeSearchBound === '1' : input.getAttribute('data-store-search-bound') === '1';
  if (isBound) return;
  if (input.dataset) { input.dataset.storeSearchBound = '1'; }
  else { input.setAttribute('data-store-search-bound', '1'); }

  function handler() {
    var filter = (input.value || '').toLowerCase();

    // 1) Links tonen/verbergen
    var links = document.querySelectorAll('.row-allemerken a.shop-list-item');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var text = ((link.textContent || '') + ' ' + (link.title || '')).toLowerCase();
      link.style.display = text.indexOf(filter) !== -1 ? '' : 'none';
    }

    // 2) Hele letterblokken tonen/verbergen o.b.v. zichtbare links
    var blocks = document.querySelectorAll('.row-allemerken .filterletter_letter');
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var blockLinks = block.querySelectorAll('a.shop-list-item');
      var anyVisible = false;
      for (var k = 0; k < blockLinks.length; k++) {
        if (blockLinks[k].style.display !== 'none') { anyVisible = true; break; }
      }
      block.style.display = anyVisible ? '' : 'none';
    }
  }

  input.addEventListener('input', handler);
  handler();
});